import { GLOBAL_TRIGGER_TYPES } from '../types';

// Check if trigger type exists in GLOBAL_TRIGGER_TYPES enum
export function isTriggerGlobal(type?: string): boolean {
  if (type) {
    return Object.values(GLOBAL_TRIGGER_TYPES).includes(type as GLOBAL_TRIGGER_TYPES);
  }
  return false;
}
